import { lazy } from 'react';




//sets the pages display settings

const OpConfirmDispatchAppConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/op-dispatch-confirm/:id/:driver_id/:queue',
      component: lazy(() => import('./OpConfirmDispatchApp')),
    },
  ],
};

export default OpConfirmDispatchAppConfig
